var csAssets = {};
